import Header from "./components/layout/Header";
import Navigation from "./components/layout/Navigation";
import Footer from "./components/layout/Footer";
import "./index.css";

function App() {
  return (
    <div>
      <Header />
      <Navigation />
      <Footer />
    </div>
  );
}

export default App;
